import { ReactNode } from "react";

type Props = {
  children?: ReactNode;
};

export default function Header({ children }: Props) {
  return (
    <header id="gamfi-header" className="gamfi-header-section default-header">
    <div className="menu-area menu-sticky">
      <div className="container">
        <div className="heaader-inner-area d-flex justify-content-between align-items-center">
          <div className="gamfi-logo-area d-flex justify-content-between align-items-center">
            <div className="logo">
              <a href="#"><img src="assets/logo-white.svg" alt="Hera Finance" width={200} /></a>
            </div>
            <div className="header-menu">
              <ul className="nav-menu">
                <li><a href="https://hera.finance" target="_blank">Hera Website</a></li>
                <li><a href="https://docs.hera.finance" target="_blank">Docs</a></li>
              </ul>
            </div>
          </div>
          <div className="gamfi-btn-area">
            <ul>
              {children}

            </ul>
          </div>
        </div>
      </div>
    </div>
    <nav className="right_menu_togle mobile-navbar-menu" id="mobile-navbar-menu">
      <div className="close-btn">
        <a id="nav-close2" className="nav-close">
          <div className="line">
            <span className="line1" />
            <span className="line2" />
          </div>
        </a>
      </div>
      <div className="sidebar-logo mb-30">
        <a href="index.html"><img src="assets/images/logo.svg" alt="" /></a>
      </div>
      <ul className="nav-menu">
        <li><a href="https://hera.finance" target="_blank">Hera Website</a></li>
        <li><a href="https://docs.hera.finance" target="_blank">Docs</a></li>
        <li className="menu-item-has-children">
          <a href="#">Balance: 14.578 <img src="assets/metis.png" alt="Metis" /></a>
          <ul className="sub-menu">
            <li><a><img src="assets/metis.png" alt="metis" /> 14.57 METIS</a></li>
            <li><a><img src="assets/usdc.png" alt="usdc" /> 214558.25 USDC</a></li>
          </ul>
        </li>
        <li>
          <button type="button" className="readon black-shape-big connectWalletBtnforMobile" data-bs-toggle="modal" data-bs-target="#exampleModal"><img src="assets/images/icons/connect_white.png" alt="Icon" />
            <span className="btn-text">Connect Wallet </span>
            <span className="hover-shape1" />
            <span className="hover-shape2" />
            <span className="hover-shape3" />
          </button>
        </li>
      </ul>
    </nav>
  </header>
  );
}
